<template>
    <BlogList
        :breadcrumb-title="data?.collection?.name"
        :posts="data?.collection?.posts"
        :total-posts="data?.collection?.postAggregation.count"
        :description="description"
        :error="error"
        :fetching="fetching"
        :has-data="!!data"
        :meta-title="title"
        :page="page"
        :response-errors="responseErrors"
        :stale="stale"
        :title="title"
        @try-again="executeQuery"
    />
</template>

<script lang="ts" setup>
import { computed, provide } from 'vue'
import { useTranslator } from '@/i18n'
import { useResponseError } from '@/helpers/errors'

import BlogList from '@/components/cms/component/blog/BlogList.vue'
import { useBlogAuthorQuery } from './BlogAuthor.generated.ts'
import { useBlogFeedLink } from '@/views/blog/composables/useBlogFeedLink.ts'

// TODO Translate meta title prop

const props = defineProps<{
    author: string
    page: number
}>()

useBlogFeedLink()

const { locale } = useTranslator()

const response = useBlogAuthorQuery({
    variables: computed(() => {
        return {
            slug: props.author,
            page: props.page,
            limit: 10,
            locale: locale.value,
        }
    }),
})
provide('response', response)
await response

const responseErrors = useResponseError(response)

const { fetching, stale, data, error, executeQuery } = response

// TODO translate
const title = computed(
    () => `Posts by ${data.value?.collection?.name || 'author'}`
)

const description =
    'Find out all you need to know about engagement rings - from diamond and gemstone guidance to trends and proposal inspiration.'
</script>
